import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import ProductImageGallery from '../../components/ProductImageGallery';

const SwitchMouseBase = () => {
  const { addToCart } = useCart();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState('black');
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  const productImages = [
    '/images/shop-products/switch-mouse-base/switch-2-mouse-base.jpg',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183204.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183158.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183209.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183213.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183222.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183226.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183229.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 184404.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 184413.png',
    '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 184421.png'
  ];

  const product = {
    id: 3,
    name: "Switch 2 Mini Joy-Con Keyboard & Mouse Base – Portable Dual-Set Gaming Accessory",
    price: "S$12.90",
    originalPrice: "S$19.90",
    description: "Portable dual-set gaming accessory combining mini keyboard and mouse base for enhanced Switch 2 gaming experience",
    specs: {
      "Material": "ABS Plastic",
      "Size": "12.5 × 7.3 × 6.2 cm",
      "Thickness": "Standard Molded ABS (Durable)",
      "Cover": "Open Dock Design",
      "Weight": "105g",
      "Color": "Black / Orange-Blue",
      "Compatibility": "Nintendo Switch 2 Joy-Con Controllers",
      "Surface": "Smooth Injection Molded Finish"
    },
    features: [
      "Dual-Set Design",
      "Portable Gaming Accessory",
      "Mini Keyboard Integration",
      "Joy-Con Compatible",
      "Durable ABS Construction",
      "Smooth Finish"
    ],
    inStock: true,
    rating: 4.4,
    reviews: 156
  };

  const colorOptions = [
    { id: 'black', name: 'Black', image: '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183226.png' },
    { id: 'orange-blue', name: 'Orange-Blue', image: '/images/shop-products/switch-mouse-base/Screenshot 2025-05-26 183222.png' }
  ];

  const addOnProducts = [
    {
      id: 'ac-adapter',
      name: 'Switch 2 AC Adapter',
      price: 'S$39.99',
      image: '/images/shop-products/switch-ac-adapter/switch 2 ac adapter.jpg',
      description: 'Official Nintendo Switch AC adapter for fast charging'
    },
    {
      id: '4in1-charger',
      name: 'Switch 2 4-in-1 Charger Dock',
      price: 'S$19.90',
      image: '/images/shop-products/switch-charger-dock/switch 2  4 in 1 controlller charger dock.jpg',
      description: 'Dual charging dock for Switch and Joy-Cons with LED indicators'
    },
    {
      id: 'screen-protector',
      name: 'Switch 2 Screen Protector',
      price: 'S$12.99',
      image: '/images/shop-products/switch-protect-screen/switch 2 protecter screen.jpg',
      description: 'High-quality tempered glass screen protector for Switch 2'
    }
  ];

  const handleAddToCart = () => {
    const selectedAddOnItems = addOnProducts.filter(addOn => selectedAddOns.includes(addOn.id));
    addToCart({
      ...product,
      quantity,
      selectedColor,
      selectedAddOns: selectedAddOnItems
    });
  };

  const handleBuyNow = () => {
    handleAddToCart();
    // Navigate to checkout
    window.location.href = '/checkout';
  };

  const toggleAddOn = (addOnId) => {
    setSelectedAddOns(prev => 
      prev.includes(addOnId) 
        ? prev.filter(id => id !== addOnId)
        : [...prev, addOnId]
    );
  };

  const calculateDiscount = () => {
    const originalPrice = parseFloat(product.originalPrice.replace('S$', ''));
    const currentPrice = parseFloat(product.price.replace('S$', ''));
    return Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <div className="bg-gray-800 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <a href="/" className="text-gray-400 hover:text-white">Home</a>
              </li>
              <li>
                <span className="text-gray-500">/</span>
              </li>
              <li>
                <a href="/shop" className="text-gray-400 hover:text-white">Shop</a>
              </li>
              <li>
                <span className="text-gray-500">/</span>
              </li>
              <li>
                <span className="text-white font-medium">Switch 2 Mini Joy-Con Keyboard & Mouse Base</span>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Product Images */}
          <div className="space-y-4">
            <ProductImageGallery 
              images={productImages}
              currentImage={productImages[selectedImage]}
              onImageChange={(imagePath) => {
                const index = productImages.findIndex(img => img === imagePath);
                if (index !== -1) {
                  setSelectedImage(index);
                }
              }}
            />
          </div>

          {/* Product Details */}
          <div className="space-y-6">
            {/* Product Title & Price */}
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">{product.name}</h1>
              
              {/* Rating and Reviews */}
              <div className="flex items-center space-x-2 mb-3">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className={`w-5 h-5 ${
                        i < Math.floor(product.rating)
                          ? 'text-yellow-400'
                          : i < product.rating
                          ? 'text-yellow-400'
                          : 'text-gray-600'
                      }`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <span className="text-white font-medium">{product.rating}</span>
                <span className="text-gray-400">({product.reviews} reviews)</span>
              </div>

              <div className="flex items-center space-x-4 mb-4">
                <span className="text-3xl font-bold text-white">{product.price}</span>
                <span className="text-xl text-gray-400 line-through">{product.originalPrice}</span>
                <div className="bg-red-600 text-white px-3 py-1 rounded-md text-sm font-bold">
                  Save S${(parseFloat(product.originalPrice.replace('S$', '')) - parseFloat(product.price.replace('S$', ''))).toFixed(2)}
                </div>
              </div>

              {/* Stock Status */}
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <span className="text-white">In Stock</span>
              </div>

              <p className="text-gray-300 text-lg">{product.description}</p>
            </div>

            {/* Color Selection */}
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-white">Choose Color</h3>
              <div className="flex space-x-4">
                {colorOptions.map((color) => (
                  <div
                    key={color.id}
                    onClick={() => setSelectedColor(color.id)}
                    className={`cursor-pointer border-2 rounded-lg overflow-hidden transition-all ${
                      selectedColor === color.id
                        ? 'border-green-500 ring-2 ring-green-500 ring-opacity-50'
                        : 'border-gray-600 hover:border-gray-500'
                    }`}
                  >
                    <div className="w-20 h-20 relative">
                      <img
                        src={color.image}
                        alt={color.name}
                        className="w-full h-full object-cover object-center"
                      />
                      {/* 水印 */}
                      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="text-white/20 text-xs font-bold select-none">
                          CHILL GAMING
                        </div>
                      </div>
                    </div>
                    <p className="text-center text-sm text-white py-1 whitespace-pre-line">{color.name}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Add-on Products */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-3 text-white">Add on</h3>
              <div className="grid grid-cols-1 gap-3">
                {addOnProducts.map((addOn) => (
                  <div
                    key={addOn.id}
                    onClick={() => toggleAddOn(addOn.id)}
                    className={`flex items-center p-3 rounded-lg border-2 cursor-pointer transition-all ${
                      selectedAddOns.includes(addOn.id)
                        ? 'border-green-500 bg-green-500 bg-opacity-10'
                        : 'border-gray-600 hover:border-gray-500'
                    }`}
                  >
                    <div className="w-12 h-12 rounded-lg overflow-hidden mr-3 flex-shrink-0">
                      <img
                        src={addOn.image}
                        alt={addOn.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-white font-medium text-sm">{addOn.name}</h4>
                      <p className="text-gray-400 text-xs">{addOn.description}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <span className="text-green-400 font-bold text-sm">+{addOn.price}</span>
                      <div className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                        selectedAddOns.includes(addOn.id)
                          ? 'border-green-500 bg-green-500'
                          : 'border-gray-500'
                      }`}>
                        {selectedAddOns.includes(addOn.id) && (
                          <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quantity Selector */}
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-white">Quantity</h3>
              <div className="flex items-center border-2 border-gray-600 rounded-lg w-fit">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="px-4 py-2 text-white hover:bg-gray-700 border-r border-gray-600"
                >
                  -
                </button>
                <span className="px-6 py-2 text-white font-medium">{quantity}</span>
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="px-4 py-2 text-white hover:bg-gray-700 border-l border-gray-600"
                >
                  +
                </button>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4 mb-6">
              <button
                onClick={handleAddToCart}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg text-lg transition-colors flex items-center justify-center space-x-2"
              >
                <span>Add to Cart</span>
                <span className="text-green-200">({product.price})</span>
              </button>
              <button
                onClick={handleBuyNow}
                className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-4 px-6 rounded-lg text-lg transition-colors"
              >
                Buy Now
              </button>
            </div>

            {/* 配送信息 */}
            <div className="border-t border-gray-700 pt-6">
              <div className="flex items-center mb-3">
                <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                  <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
                </svg>
                <span className="text-gray-300">Free Meet Up (Available at Sengkang & Orchard locations)</span>
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <span className="text-gray-300">Available Shipping</span>
              </div>
            </div>

          </div>
        </div>

        {/* Product Details Tabs */}
        <div className="mt-12">
          <div className="border-b border-gray-700">
            <nav className="-mb-px flex space-x-8">
              {['overview', 'specifications', 'reviews'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-2 px-1 border-b-2 font-medium text-sm capitalize ${
                    activeTab === tab
                      ? 'border-green-500 text-green-400'
                      : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </nav>
          </div>

          <div className="mt-8">
            {activeTab === 'overview' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-4">Product Overview</h3>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    The Switch Mouse Base is designed to provide maximum comfort during extended gaming sessions. 
                    Made with high-quality memory foam, it offers excellent support for your wrist and hand, 
                    reducing fatigue and improving your gaming performance.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    The ergonomic design ensures proper hand positioning while the non-slip base keeps it 
                    securely in place on any surface. The removable and washable cover makes maintenance 
                    easy, while the portable design allows you to take comfort anywhere.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-4">Key Features</h3>
                  <ul className="space-y-2">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-300">
                        <svg className="w-5 h-5 text-green-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div>
                <h3 className="text-2xl font-bold text-white mb-8">Technical Specifications</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                  {Object.entries(product.specs).map(([key, value], index) => (
                    <div key={key} className={`flex justify-between items-center py-4 px-2 ${index < Object.entries(product.specs).length - 1 ? 'border-b border-gray-700' : ''}`}>
                      <span className="text-gray-300 font-medium text-sm uppercase tracking-wide">{key}:</span>
                      <span className="text-white font-semibold text-right max-w-xs">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'reviews' && (
              <div>
                <h3 className="text-xl font-semibold text-white mb-6">Customer Reviews</h3>
                <div className="space-y-6">
                  <div className="bg-gray-800 rounded-lg p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                          <span className="text-white font-bold">J</span>
                        </div>
                        <div className="ml-3">
                          <h4 className="text-white font-medium">John Gamer</h4>
                          <div className="flex text-yellow-400">
                            ★★★★★
                          </div>
                        </div>
                      </div>
                      <span className="text-gray-400 text-sm">2 days ago</span>
                    </div>
                    <p className="text-gray-300">
                      "This mouse base is amazing! The memory foam is so comfortable and it really helps 
                      with wrist fatigue during long gaming sessions. Highly recommended!"
                    </p>
                  </div>

                  <div className="bg-gray-800 rounded-lg p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                          <span className="text-white font-bold">S</span>
                        </div>
                        <div className="ml-3">
                          <h4 className="text-white font-medium">Sarah M.</h4>
                          <div className="flex text-yellow-400">
                            ★★★★☆
                          </div>
                        </div>
                      </div>
                      <span className="text-gray-400 text-sm">1 week ago</span>
                    </div>
                    <p className="text-gray-300">
                      "Great quality and very comfortable. The non-slip base works perfectly and the 
                      washable cover is a nice touch. Good value for money."
                    </p>
                  </div>

                  <div className="bg-gray-800 rounded-lg p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                          <span className="text-white font-bold">M</span>
                        </div>
                        <div className="ml-3">
                          <h4 className="text-white font-medium">Mike R.</h4>
                          <div className="flex text-yellow-400">
                            ★★★★★
                          </div>
                        </div>
                      </div>
                      <span className="text-gray-400 text-sm">2 weeks ago</span>
                    </div>
                    <p className="text-gray-300">
                      "Perfect for my Switch gaming setup. The ergonomic design really makes a difference 
                      and the portable design means I can use it anywhere. Love it!"
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwitchMouseBase;